module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-left.b8c593c7.svg";